/**
 * @file 红包相关store
 */
import request from '../../request';
import {getConfig} from '@/pages/pano-feed/constant/RequestConfig.js';

const state = () => ({
    // 红包相关配置
    config: {}
});

const mutations = {
    setConfig(state, data) {
        state.config = data;
    }
};

const getters = {
    activityInfo: state => state.config.activity_info || null,
    calendarRemindInfo: state => state.config.calendar_event || null
};

const actions = {
    getConfig({commit, rootState}, params) {
        return request(getConfig).then(res => {
            if (res.errno === 0) {
                commit('setConfig', res.data);
            }
            else {
                throw res.errstr || '网络繁忙，请稍后再试';
            }
        });
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};